<template>
  <div class="nav-bar-container">
    <router-link
      class="router-link"
      to="/trucks-for-sale?page=1"
      active-class="active"
      >Home
    </router-link>
    <!-- <router-link class="router-link" to="/inquired" active-class="active"
      >Inquired
    </router-link> -->
    <router-link class="router-link" to="/auction-lists" active-class="active"
      >Calendar
    </router-link>
    <router-link
      class="router-link"
      to="/profile"
      rel="nofollow"
      active-class="active"
      >Profile
    </router-link>
  </div>
</template>
<script>
  export default {
    name: 'PageNavBar'
  }
</script>

<style lang="scss">
  .nav-bar-container {
    width: 100%;
    height: 56px;
    display: flex;
    .router-link {
      cursor: pointer;
      margin-top: 8px;
      padding: 26px 26px 0 26px;
      @include font;
      @include setAllBackground(
        $at-red,
        $icon-white-home,
        $icon-white-gavel,
        $icon-white-account-circle
      );
      @include centerBackground;
    }
    .router-link:not(.active) {
      color: $white;
    }
    .router-link {
      color: $at-red;
    }
  }

  @media screen and (max-width: 800px) {
    .nav-bar-container {
      text-align: center;
      .router-link {
        flex: 1;
        margin: 0;
        padding: 28px 0;
        @include setAllBackground(
          $at-red,
          $icon-home,
          $icon-gavel,
          $icon-account-circle
        );
        @include centerBackground(center 4px);
      }
      .router-link:not(.active) {
        color: $gray-4;
      }
    }
  }
</style>
